<script>
    import { langTextStore } from "../store/langtexts.js";
    import LangSelector from "./LangSelector.svelte";
    import { getContext } from "svelte";
    import { push } from "svelte-spa-router";
    import IconChevronRight from "../Vectors/chevronright.svelte";

    const { close } = getContext("modal");

    export let langs = [];
    export let showChoice = false;
    export let warningText = "";

    function setLang(lang) {
        langTextStore.setLang(lang);
        showChoice = false;
    }
    function showChoices() {
        showChoice = true;
    }
</script>

{#if warningText.length > 0}
    <h2 class="highlight">{$langTextStore.langName} {warningText}</h2>
    <p>{$langTextStore.getText("general-text-choose-another-lang")}</p>
{/if}
<LangSelector
    extraClass="lang-switcher-modal"
    {langs}
    showChoice={true}
    on:langChosen={close}
/>
<p class="mt-4">
    <span
        on:click={() => {
            push("#/dashboard/factories");
            close();
        }}
        class="d-block mb-1 choice c-pointer underline link"
    >
        {$langTextStore.getText("general-text-keep-language-return-dashboard")}
        <IconChevronRight /></span
    >
</p>
